<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <page-header-new :title="$t('Gamification_GamesHub_Page_Title')" />
    <page-content>
      <games-to-purchase :core-games="games" />
    </page-content>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import { projectEndpoint } from '@/core/helpers'
import PageContent from '@/common/components/page/PageContent'
import GamesToPurchase from '@/modules/gamification/components/games-hub-dashboard/GamesToPurchase'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
export default {
  name: 'GamesCataloguePage',
  components: { PageHeaderNew, GamesToPurchase, PageContent, RestPage },
  data() {
    return {
      games: []
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'games',
        handler: data => {
          this.games = data
        }
      })
    }
  }
}
</script>

<style scoped>
>>> .page-content {
  background-color: #fff;
  height: calc(100vh - 64px);
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GamesCataloguePage.vue